import {
  FETCH_MATERIAL_DETAILS_REQUEST,
  FETCH_MATERIAL_DETAILS_SUCCESS,
  FETCH_MATERIAL_DETAILS_FAILURE,
  SAVE_MATERIAL_DETAIL_REQUEST,
  SAVE_MATERIAL_DETAIL_SUCCESS,
  SAVE_MATERIAL_DETAIL_FAILURE,
  DELETE_MATERIAL_DETAIL_REQUEST,
  DELETE_MATERIAL_DETAIL_SUCCESS,
  DELETE_MATERIAL_DETAIL_FAILURE,
} from './types';

const INITIAL_STATE = {
  materialDetailList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MATERIAL_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MATERIAL_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        materialDetailList: action.payload,
      };

    case FETCH_MATERIAL_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        materialDetailList: [],
      };
    case SAVE_MATERIAL_DETAIL_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_MATERIAL_DETAIL_SUCCESS:
      return {
        ...state,
      };

    case SAVE_MATERIAL_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_MATERIAL_DETAIL_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_MATERIAL_DETAIL_SUCCESS:
      return {
        ...state,
      };

    case DELETE_MATERIAL_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
